module.exports = __webpack_public_path__ + "img/motivation.1d2acc7e.png";